import { H5 } from "@sellar-io/components";
import { SpinnerLegacy } from "../../../../components";
import {
  RadioGroup,
  RadioGroupLabel,
  RadioGroupOption,
  RadioGroupContainer,
} from "../../../../components/radioSelector/RadioGroup";
import { useDeliveryOptions } from "../../../../hooks/useDeliveryOptions";

import { CheckoutSelectedFulfillmentType } from "../../../stockList";

export const FulfillmentTypeRadioGroup = ({
  fulfillmentType,
  onChange,
  postcode,
  distributionDeliveryEstimate,
  distributionOrderBy,
}: {
  fulfillmentType: CheckoutSelectedFulfillmentType;
  onChange: (fulfillmentType: CheckoutSelectedFulfillmentType) => void;
  postcode?: string;
  distributionDeliveryEstimate?: string;
  distributionOrderBy?: string;
}) => {
  const { deliveryOptions, isFetched } = useDeliveryOptions({
    postcode,
    hiddenOptions: ["apc", "ups", "dx", "dxDropOff"],
    includeShadowRoutes: true,
  });

  if (!isFetched) return <SpinnerLegacy />;

  return (
    <RadioGroup
      value={fulfillmentType}
      onChange={(value) => onChange(value as CheckoutSelectedFulfillmentType)}
    >
      <RadioGroupLabel className={"sr-only"}>Fulfillment Type</RadioGroupLabel>
      <RadioGroupContainer>
        {deliveryOptions.map((option) => (
          <RadioGroupOption value={option.value} key={option.value}>
            <div>
              <H5>{option.name}</H5>
              {option.value === "sellarDistribution" && (
                <div className="mt-1 text-sm text-zinc-600">
                  {distributionOrderBy && <p>{distributionOrderBy}</p>}
                  <p className="font-bold">
                    {distributionDeliveryEstimate ??
                      "Delivery date unavailable"}
                  </p>
                </div>
              )}
            </div>
          </RadioGroupOption>
        ))}
      </RadioGroupContainer>
    </RadioGroup>
  );
};
